//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import {
  nameToStreamType,
  StreamsDrawerStreamType,
} from '../streams-drawer-constants';

import { IStream } from '@streams-drawer/model/IStream';
import template from './streams-drawer-sidebar.html';
import './streams-drawer-sidebar.less';

class StreamsDrawerSidebar {
  public selectStream;
  public selectSummary;
  public taggedByCuralatePendingCount: number;
  public connectPendingCount: number;

  constructor(private TrackingService) {}

  public onStreamClick(stream) {
    const streamType = nameToStreamType(stream);
    this.TrackingService.recordEvent(
      this.TrackingService.CATEGORY_STREAMS,
      this.TrackingService.ACTION_STREAMS_SELECT_STREAM_FROM_SIDEBAR,
      `collection-type=${streamType}`,
    );

    this.selectStream({ stream });
  }

  public onSummaryClick() {
    this.selectSummary();
  }
}

angular.module('curalate').component('streamsDrawerSidebar', {
  bindings: {
    isContentDiscoveryEnabled: '<',
    isModerationServices: '<',
    isModerationServicesPublisherClient: '<',
    isRefreshingStreams: '<',
    launchContext: '<',
    onOpenNewStreamModal: '&',
    recommendationsStreams: '<',
    selectedStream: '<',
    selectStream: '&',
    selectSummary: '&',
    streams: '<',
    taggedByCuralatePendingCount: '<',
    connectPendingCount: '<',
    shouldNotAllowUgcStreams: '<',
  },
  controller: ['TrackingService', StreamsDrawerSidebar],
  template,
});
